import React from "react";
import { defineMessages } from "react-intl";
import { withTheme } from "styled-components/native";
import { LinkedRow, RowText, StoredRoundImage } from "cci-component";
import { SessionQuery, findApplicationUsersByNameQuery, findApplicationUsersByUserBusinessQuery } from "cci-data";
import ImmutableList from "../../list/ImmutableList";
import MutableList from "../../list/MutableList";

const messages = defineMessages({
  searchUsers: {
    id: "searchUsers",
    defaultMessage: "Search Users"
  }
});

/**
 * Users list page containing the search bar along the top,
 * the user list in the middle and the add button along the bottom.
 */
const List = ({isMutable = true, rootPath = "users", ...props }) => {
  const ListComponent = isMutable ? MutableList : ImmutableList,
    userBusiness = !props.theme.hideUserBusinesses;

  return (
    <SessionQuery>
      {({ wrapBusiness, wrapOffice }) => (
        <ListComponent
          {...props}
          listTitle={props.listTitle}
          queryName={userBusiness ? "findApplicationUsersByUserBusiness" : "findApplicationUsersByName"}
          query={userBusiness ? findApplicationUsersByUserBusinessQuery : findApplicationUsersByNameQuery}
          variables={userBusiness ? wrapBusiness({ name: "" }) : wrapOffice({ name: "" })}
          filterProperty="name"
          searchPlaceholder={messages.searchUsers}
          newUrl={`/${rootPath}/new`}
          recordRenderer={({ key, style }, rowData) => (
            <LinkedRow
              key={key}
              style={style}
              to={{
                pathname: `/${rootPath}/${rowData.id}`
              }}
            >
              {!props.theme.hideUserInspectPhoto && (
                <StoredRoundImage
                  size={40}
                  imageId={rowData.contact.photoId}
                  placeholder={require("../../assets/images/userPlaceholder.png")}
                />
              )}

              <RowText flex={1} margins="0 0 0 13px">
                {rowData.contact.firstName} {rowData.contact.lastName}
              </RowText>
            </LinkedRow>
          )}
        />
      )}
    </SessionQuery>
  );
};

export default withTheme(List);
